import { Helmet } from "react-helmet-async"
import { useParams } from "../../../../../router-utils"
import { TripSourcePayments } from "../../../../../TripSources"

export default function TripSourceIncomingPayments() {
	const { tripSourceId } = useParams(
		"/trip-sources/:tripSourceId/payments/incoming"
	)
	return (
		<>
			<Helmet>
				<title>Incoming Payments | B2B Source</title>
			</Helmet>
			<TripSourcePayments tripSourceId={tripSourceId} paymentType="credit" />
		</>
	)
}
